<div
  class="opt-page"
  [class.opt-page--light]="!isDarkMode()"
  (click)="closeAllDropdowns()"
>
  <header class="opt-header">
    <div class="opt-header__brand">
      <div class="opt-header__icon" aria-hidden="true">
        <mat-icon>insights</mat-icon>
      </div>
      <div>
        <h1 class="opt-header__title">Optimization</h1>
        <p class="opt-header__subtitle">Port stay consumption comparison and analysis</p>
      </div>
    </div>
    <div class="opt-header__actions">
      <button
        type="button"
        class="opt-btn opt-btn--ghost"
        (click)="clearGlobalFilters(); $event.stopPropagation()"
      >
        <mat-icon>close</mat-icon>
        <span>Clear</span>
      </button>
      <button
        type="button"
        class="opt-btn opt-btn--screenshot"
        (click)="takeScreenshot()"
        matTooltip="Capture Screenshot"
      >
        <mat-icon>photo_camera</mat-icon>
        <span>Screenshot</span>
      </button>
    </div>
  </header>

  <main class="opt-main">

    <section class="opt-filters">
      <div class="opt-filters__grid">
        <div class="opt-filters__field">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Segment"
            placeholder="Select Segment"
            [options]="segmentFilterOptions"
            [selected]="selectedSegmentKeys"
            (selectedChange)="onSegmentSelectionChange($event)">
          </app-pc-multi-select-filter>
        </div>
        <div class="opt-filters__field">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Vessel Name"
            [placeholder]="vesselDropdownPlaceholder"
            emptyMessage="No vessels available"
            [options]="vesselNameOptions"
            [selected]="selectedVesselNames"
            (selectedChange)="onVesselSelectionChange($event)">
          </app-pc-multi-select-filter>
        </div>
        <div class="opt-filters__field">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Operation"
            placeholder="Select Operation"
            [optionItems]="operationFilterOptionItems"
            [selected]="selectedOperationValues"
            (selectedChange)="onOperationSelectionChange($event)">
          </app-pc-multi-select-filter>
        </div>
        <div class="opt-filters__field">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Port Name"
            placeholder="Select Port"
            allLabel="All"
            [optionItems]="portFilterOptionItems"
            [selected]="selectedPortNames"
            (selectedChange)="onPortSelectionChange($event)">
          </app-pc-multi-select-filter>
        </div>
        <div class="opt-filters__field">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Cargo Type"
            placeholder="Select Cargo Type"
            [options]="cargoTypeFilterOptions"
            [selected]="selectedOilTypes"
            (selectedChange)="onOilSelectionChange($event)">
          </app-pc-multi-select-filter>
        </div>
        <div class="opt-filters__field">
          <label class="opt-filters__label" for="optExpectedCargoQty">Expected Cargo Qty</label>
          <div class="opt-filters__input-wrap">
            <input
              id="optExpectedCargoQty"
              type="text"
              inputmode="decimal"
              class="opt-filters__input"
              [ngModel]="expectedCargoQtyDisplay"
              (ngModelChange)="onExpectedCargoQtyInput($event)"
              (blur)="onExpectedCargoQtyBlur()"
              (focus)="onExpectedCargoQtyFocus()"
              placeholder="Enter expected cargo qty"
            />
            <span class="opt-filters__input-unit">m3</span>
          </div>
        </div>
        <div class="opt-filters__field">
          <label class="opt-filters__label" for="optExpectedCargoDays">Expected Cargo Days</label>
          <div class="opt-filters__input-wrap">
            <input
              id="optExpectedCargoDays"
              type="number"
              class="opt-filters__input"
              [(ngModel)]="filters.expectedCargoDays"
              (ngModelChange)="onExpectedCargoDaysChange()"
              placeholder="Auto from cargo days"
              min="0"
              step="any"
            />
            <span class="opt-filters__input-unit">Days</span>
          </div>
        </div>
        <div class="opt-filters__field">
          <label class="opt-filters__label" for="optExpectedIdleTime">Expected Idle Time</label>
          <div class="opt-filters__input-wrap">
            <input
              id="optExpectedIdleTime"
              type="number"
              class="opt-filters__input"
              [(ngModel)]="filters.expectedIdleTimeDays"
              (ngModelChange)="onExpectedIdleTimeChange()"
              placeholder="Enter idle time"
              min="0"
              step="any"
            />
            <span class="opt-filters__input-unit">Days</span>
          </div>
        </div>
        <div class="opt-filters__field opt-filters__field--action">
          <span class="opt-filters__action-spacer" aria-hidden="true"></span>
          <button
            type="button"
            class="opt-btn opt-btn--analyse"
            (click)="calculateOptimization(); $event.stopPropagation()"
            [disabled]="isLoading"
          >
            <mat-spinner *ngIf="isLoading" diameter="18"></mat-spinner>
            <mat-icon *ngIf="!isLoading">bar_chart</mat-icon>
            <span>Analyse</span>
          </button>
        </div>
      </div>
    </section>

    <div class="opt-dashboard opt-timeline">

      <!-- ACTUAL VALUES SECTION -->
      <section class="opt-section opt-section--actual">
        <div class="opt-section__rail">
          <div class="opt-section__badge opt-section__badge--actual">
            <mat-icon>location_city</mat-icon>
          </div>
          <span class="opt-section__name">Actual Values</span>
        </div>
        <div class="opt-section__panel">
          <!-- SKELETON PLACEHOLDER -->
          <div class="opt-section-skeleton" *ngIf="isLoading || isLoadingActual">
            <div class="opt-actual-hero-metric">
              <div class="skeleton-bar circle-skeleton"></div>
              <div class="opt-actual-hero-metric__copy" style="width: 50%;">
                <div class="skeleton-bar" style="width: 40%; height: 10px; margin-bottom: 6px;"></div>
                <div class="skeleton-bar" style="width: 70%; height: 14px;"></div>
              </div>
              <div class="skeleton-bar" style="width: 100px; height: 32px; margin-left: auto;"></div>
            </div>
            <div class="opt-kpi-grid opt-kpi-grid--4">
              <div class="opt-kpi-card-sk" *ngFor="let _ of [1,2,3,4,5,6,7]">
                <div class="skeleton-bar circle-sk-sm"></div>
                <div style="flex: 1;">
                  <div class="skeleton-bar" style="width: 80%; height: 10px; margin-bottom: 8px;"></div>
                  <div class="skeleton-bar" style="width: 50%; height: 20px;"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- REAL CONTENT -->
          <div *ngIf="!isLoading && !isLoadingActual">
            <div
              class="opt-actual-hero-metric"
              [class.opt-actual-hero-metric--populated]="hasAverageCargoQty()"
              aria-label="Historical Average Cargo Quantity for Actual Values"
            >
              <div class="opt-actual-hero-metric__icon" aria-hidden="true">
                <mat-icon>scale</mat-icon>
              </div>
              <div class="opt-actual-hero-metric__copy">
                <span class="opt-actual-hero-metric__eyebrow">Actual Values</span>
                <span class="opt-actual-hero-metric__label">Historical Average Cargo Quantity</span>
              </div>
              <div class="opt-actual-hero-metric__value-wrap">
                <strong class="opt-actual-hero-metric__value">{{ formatAverageCargoQtyDisplay() }}</strong>
                <span class="opt-actual-hero-metric__unit">m³</span>
              </div>
            </div>

            <div class="opt-kpi-grid opt-kpi-grid--4">
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--purple">
                  <mat-icon>local_gas_station</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label opt-kpi-card__label--long">Bunker Consumption for Cargo Operation (MT)</span>
                  <strong class="opt-kpi-card__value">{{ formatActualField('expected_total_consumption') }}</strong>
                  <span class="opt-kpi-card__unit">MT</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--purple">
                  <mat-icon>local_gas_station</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label opt-kpi-card__label--long">Average Bunker Consumption for 10000 m³ Cargo</span>
                  <strong class="opt-kpi-card__value">{{ formatActualField('avg_consumption_per_10000_mt') }}</strong>
                  <span class="opt-kpi-card__unit">MT</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--purple">
                  <mat-icon>calendar_today</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Days Required for Cargo Operation</span>
                  <strong class="opt-kpi-card__value">{{ formatActualField('cargo_days_required', 2) }}</strong>
                  <span class="opt-kpi-card__unit">Days</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--purple">
                  <mat-icon>trending_up</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Load / Discharge Rate</span>
                  <strong class="opt-kpi-card__value">{{ formatActualField('avg_loading_discharging_rate') }}</strong>
                  <span class="opt-kpi-card__unit">m³/hr</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--purple">
                  <mat-icon>hourglass_empty</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Idle Consumption / Day</span>
                  <strong class="opt-kpi-card__value">{{ formatActualField('idle_consumption_per_day') }}</strong>
                  <span class="opt-kpi-card__unit">MT/Day</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--purple">
                  <mat-icon>navigation</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Total Manoeuvring Consumption (In/Out)</span>
                  <strong class="opt-kpi-card__value">{{ formatActualField('manoevering_consumption_per_day') }}</strong>
                  <span class="opt-kpi-card__unit">MT</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--purple">
                  <mat-icon>schedule</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Manoeuvring Time (In/Out)</span>
                  <strong class="opt-kpi-card__value">{{ formatActualField('manoevering_time_days', 2) }}</strong>
                  <span class="opt-kpi-card__unit">Days</span>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      <!-- EXPECTED VALUES SECTION -->
      <section class="opt-section opt-section--expected">
        <div class="opt-section__rail">
          <div class="opt-section__badge opt-section__badge--expected">
            <mat-icon>gps_fixed</mat-icon>
          </div>
          <span class="opt-section__name">Expected Values</span>
        </div>
        <div class="opt-section__panel">
          <!-- SKELETON PLACEHOLDER -->
          <div class="opt-section-skeleton" *ngIf="isLoading || isLoadingExpected">
            <div class="opt-expected-hero-metric">
              <div class="skeleton-bar circle-skeleton"></div>
              <div class="opt-expected-hero-metric__copy" style="width: 50%;">
                <div class="skeleton-bar" style="width: 40%; height: 10px; margin-bottom: 6px;"></div>
                <div class="skeleton-bar" style="width: 70%; height: 14px;"></div>
              </div>
              <div class="skeleton-bar" style="width: 100px; height: 32px; margin-left: auto;"></div>
            </div>
            <div class="opt-kpi-grid opt-kpi-grid--4">
              <div class="opt-kpi-card-sk" *ngFor="let _ of [1,2,3,4,5,6]">
                <div class="skeleton-bar circle-sk-sm"></div>
                <div style="flex: 1;">
                  <div class="skeleton-bar" style="width: 80%; height: 10px; margin-bottom: 8px;"></div>
                  <div class="skeleton-bar" style="width: 50%; height: 20px;"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- REAL CONTENT -->
          <div *ngIf="!isLoading && !isLoadingExpected">
            <div
              class="opt-expected-hero-metric"
              [class.opt-expected-hero-metric--populated]="hasExpectedCargoQty()"
              aria-label="Expected Cargo Quantity for Expected Values"
            >
              <div class="opt-expected-hero-metric__icon" aria-hidden="true">
                <mat-icon>scale</mat-icon>
              </div>
              <div class="opt-expected-hero-metric__copy">
                <span class="opt-expected-hero-metric__eyebrow">Expected Values</span>
                <span class="opt-expected-hero-metric__label">Expected Cargo Quantity</span>
              </div>
              <div class="opt-expected-hero-metric__value-wrap">
                <strong class="opt-expected-hero-metric__value">{{ formatExpectedCargoQtyDisplay() }}</strong>
                <span class="opt-expected-hero-metric__unit">m³</span>
              </div>
            </div>

            <div
              class="opt-expected-hero-metric opt-expected-hero-metric--bunker"
              [class.opt-expected-hero-metric--populated]="hasTotalExpectedBunkerConsumption()"
              aria-label="Total Expected Bunker Consumption"
            >
              <div class="opt-expected-hero-metric__icon" aria-hidden="true">
                <mat-icon>local_gas_station</mat-icon>
              </div>
              <div class="opt-expected-hero-metric__copy">
                <span class="opt-expected-hero-metric__eyebrow">Expected Values</span>
                <span class="opt-expected-hero-metric__label">Total Expected Bunker Consumption</span>
              </div>
              <div class="opt-expected-hero-metric__value-wrap opt-expected-hero-metric__value-wrap--editable">
                <input
                  type="number"
                  class="opt-hero-editable-input"
                  step="any"
                  min="0"
                  [ngModel]="totalExpectedBunkerConsumption"
                  (ngModelChange)="onTotalExpectedBunkerChange($event)"
                  [attr.value]="totalExpectedBunkerConsumption"
                  [attr.data-value]="formatTotalExpectedBunkerDisplay()"
                  aria-label="Total Expected Bunker Consumption"
                />
                <strong class="opt-expected-hero-metric__value opt-hero-screenshot-value" aria-hidden="true">{{ formatTotalExpectedBunkerDisplay() }}</strong>
                <span class="opt-expected-hero-metric__unit">MT</span>
              </div>
            </div>

            <div class="opt-kpi-grid opt-kpi-grid--4">
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--green">
                  <mat-icon>local_gas_station</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label opt-kpi-card__label--long">Bunker Consumption for Cargo Operation (MT)</span>
                  <strong class="opt-kpi-card__value">{{ formatExpectedField('expected_total_consumption') }}</strong>
                  <span class="opt-kpi-card__unit">MT</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--green">
                  <mat-icon>calendar_today</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Days Required for Cargo Operation</span>
                  <strong class="opt-kpi-card__value">{{ formatExpectedField('cargo_days_required', 2) }}</strong>
                  <span class="opt-kpi-card__unit">Days</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--green">
                  <mat-icon>trending_up</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Load / Discharge Rate</span>
                  <strong class="opt-kpi-card__value">{{ formatExpectedField('avg_loading_discharging_rate') }}</strong>
                  <span class="opt-kpi-card__unit">m³/hr</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--green">
                  <mat-icon>hourglass_empty</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Idle Consumption / Day</span>
                  <strong class="opt-kpi-card__value">{{ formatExpectedField('idle_consumption_per_day') }}</strong>
                  <span class="opt-kpi-card__unit">MT/Day</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--green">
                  <mat-icon>navigation</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label opt-kpi-card__label--long">Total Manoeuvring Consumption (In/Out)</span>
                  <strong class="opt-kpi-card__value">{{ formatExpectedField('manoevering_consumption_per_day') }}</strong>
                  <span class="opt-kpi-card__unit">MT</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--green">
                  <mat-icon>schedule</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Manoeuvring Time (In/Out)</span>
                  <strong class="opt-kpi-card__value">{{ formatExpectedField('manoevering_time_days', 2) }}</strong>
                  <span class="opt-kpi-card__unit">Days</span>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      <!-- AS PER TECHNICAL BASELINE -->
      <section class="opt-section opt-section--baseline">
        <div class="opt-section__rail">
          <div class="opt-section__badge opt-section__badge--baseline">
            <mat-icon>description</mat-icon>
          </div>
          <span class="opt-section__name">As Per Technical Baseline</span>
        </div>
        <div class="opt-section__panel">
          <!-- SKELETON PLACEHOLDER -->
          <div class="opt-section-skeleton" *ngIf="isLoading">
            <div class="opt-baseline-hero-metric">
              <div class="skeleton-bar circle-skeleton"></div>
              <div class="opt-baseline-hero-metric__copy" style="width: 50%;">
                <div class="skeleton-bar" style="width: 40%; height: 10px; margin-bottom: 6px;"></div>
                <div class="skeleton-bar" style="width: 70%; height: 14px;"></div>
              </div>
              <div class="skeleton-bar" style="width: 100px; height: 32px; margin-left: auto;"></div>
            </div>
            <div class="opt-kpi-grid opt-kpi-grid--4">
              <div class="opt-kpi-card-sk" *ngFor="let _ of [1,2,3,4,5,6]">
                <div class="skeleton-bar circle-sk-sm"></div>
                <div style="flex: 1;">
                  <div class="skeleton-bar" style="width: 80%; height: 10px; margin-bottom: 8px;"></div>
                  <div class="skeleton-bar" style="width: 50%; height: 20px;"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- REAL CONTENT -->
          <div *ngIf="!isLoading">
            <div
              class="opt-baseline-hero-metric"
              [class.opt-baseline-hero-metric--populated]="hasTechnicalBaselineTotal()"
              aria-label="Total Technical Baseline Consumption"
            >
              <div class="opt-baseline-hero-metric__icon" aria-hidden="true">
                <mat-icon>local_gas_station</mat-icon>
              </div>
              <div class="opt-baseline-hero-metric__copy">
                <span class="opt-baseline-hero-metric__eyebrow">As Per Technical Baseline</span>
                <span class="opt-baseline-hero-metric__label">Total Technical Baseline Consumption</span>
              </div>
              <div class="opt-baseline-hero-metric__value-wrap">
                <strong class="opt-baseline-hero-metric__value">{{ formatTechnicalBaselineTotalDisplay() }}</strong>
                <span class="opt-baseline-hero-metric__unit">MT</span>
              </div>
            </div>

            <div class="opt-kpi-grid opt-kpi-grid--4">
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--blue">
                  <mat-icon>local_gas_station</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label opt-kpi-card__label--long">Bunker Consumption for Cargo Operation (MT)</span>
                  <strong class="opt-kpi-card__value">{{ formatBaselineBunkerConsumption() }}</strong>
                  <span class="opt-kpi-card__unit">MT</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--blue">
                  <mat-icon>calendar_today</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Days Required for Cargo Operation</span>
                  <strong class="opt-kpi-card__value">{{ formatBaselineDaysRequired() }}</strong>
                  <span class="opt-kpi-card__unit">Days</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--blue">
                  <mat-icon>trending_up</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Load / Discharge Rate</span>
                  <strong class="opt-kpi-card__value">{{ formatBaselineLoadDischargeRate() }}</strong>
                  <span class="opt-kpi-card__unit">m³/hr</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--blue">
                  <mat-icon>hourglass_empty</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Idle Consumption </span>
                  <strong class="opt-kpi-card__value">{{ formatBaselineIdleConsumptionPerDay() }}</strong>
                  <span class="opt-kpi-card__unit">MT</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--blue">
                  <mat-icon>navigation</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Total Manoeuvring Consumption (In/Out)</span>
                  <strong class="opt-kpi-card__value">{{ formatBaselineManoeuvringConsumption() }}</strong>
                  <span class="opt-kpi-card__unit">MT</span>
                </div>
              </article>
              <article class="opt-kpi-card">
                <div class="opt-kpi-card__icon opt-kpi-card__icon--blue">
                  <mat-icon>schedule</mat-icon>
                </div>
                <div class="opt-kpi-card__body">
                  <span class="opt-kpi-card__label">Manoeuvring Time (In/Out)</span>
                  <strong class="opt-kpi-card__value">{{ formatBaselineManoeuvringTime() }}</strong>
                  <span class="opt-kpi-card__unit">Days</span>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      <!-- HISTORICAL VOYAGES & OPTIMIZATION GUIDANCE (Placed Last) -->
      <section class="opt-section opt-section--vessel-port">
        
        <div class="opt-section__rail">
          <div class="opt-section__badge opt-section__badge--vessel-port">
            <mat-icon>directions_boat</mat-icon>
          </div>
          <span class="opt-section__name">Voyage Details &amp; Guidance</span>
        </div>
        <div class="opt-section__panel">
          <!-- SKELETON LOADER -->
          <div class="opt-section-skeleton" *ngIf="isLoading || isLoadingVesselPort">
            <div class="skeleton-bar" style="width: 100%; height: 52px; border-radius: 12px; margin-bottom: 16px;"></div>
            <div class="opt-table-responsive-container">
              <table class="opt-voyage-table">
                <thead>
                  <tr>
                    <th *ngFor="let _ of [1,2,3,4,5,6,7,8,9,10]"><div class="skeleton-bar" style="width: 60px;"></div></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let _ of [1,2,3,4,5]">
                    <td *ngFor="let _ of [1,2,3,4,5,6,7,8,9,10]"><div class="skeleton-bar"></div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- REAL CONTENT -->
          <div *ngIf="!isLoading && !isLoadingVesselPort">
            <!-- Summary Hero Banner -->
            <div
              class="opt-vessel-port-hero opt-vessel-port-hero--populated"
              *ngIf="vesselPortVisits.length > 0"
              aria-label="Vessel and Port Information"
            >
              <div class="opt-vessel-port-hero__icon" aria-hidden="true">
                <mat-icon>format_list_bulleted</mat-icon>
              </div>
              <div class="opt-vessel-port-hero__copy">
                <span class="opt-vessel-port-hero__eyebrow">Filtered Port Calls &amp; Guidance List</span>
                <span class="opt-vessel-port-hero__label">
                  {{ selectedVesselNames[0] || (vesselPortVisits[0]?.vessel_name || 'All Vessels') }}
                  <span *ngIf="selectedPortNames[0] || vesselPortVisits[0]?.port">
                    &bull; {{ selectedPortNames[0] || vesselPortVisits[0]?.port }}
                  </span>
                </span>
              </div>

              <!-- Search box inside list -->
              <div class="opt-voyage-search-box" *ngIf="vesselPortVisits.length > 3">
                <mat-icon>search</mat-icon>
                <input
                  type="text"
                  class="opt-voyage-search-input"
                  placeholder="Search voyages, ports…"
                  [(ngModel)]="optVoyageSearchTerm"
                />
                <button
                  *ngIf="optVoyageSearchTerm"
                  type="button"
                  class="opt-search-clear-btn"
                  (click)="optVoyageSearchTerm = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <div class="opt-vessel-port-hero__status-wrap">
                <span class="opt-vessel-port-count-badge">
                  {{ filteredVesselPortVisits.length }} {{ filteredVesselPortVisits.length === 1 ? 'Item' : 'Items' }} Listed
                </span>

                <!-- View mode toggle: List (default) vs Cards -->
                <div class="opt-view-toggle">
                  <button
                    type="button"
                    class="opt-view-toggle-btn"
                    [class.opt-view-toggle-btn--active]="optVoyageViewMode === 'list'"
                    (click)="optVoyageViewMode = 'list'"
                    matTooltip="Table List View"
                  >
                    <mat-icon>view_list</mat-icon>
                    <span>List</span>
                  </button>
                  <button
                    type="button"
                    class="opt-view-toggle-btn"
                    [class.opt-view-toggle-btn--active]="optVoyageViewMode === 'cards'"
                    (click)="optVoyageViewMode = 'cards'"
                    matTooltip="Cards View"
                  >
                    <mat-icon>grid_view</mat-icon>
                    <span>Cards</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Empty prompt when no vessel/port selected -->
            <div class="opt-vessel-port-empty" *ngIf="!hasVesselPortSelection()">
              <mat-icon>travel_explore</mat-icon>
              <span>Select a <strong>Vessel Name</strong> or <strong>Port Name</strong> in the filters above to display the voyage-wise list and optimization guidance.</span>
            </div>

            <!-- Empty notice when search was done but no records found -->
            <div class="opt-vessel-port-empty" *ngIf="hasVesselPortSelection() && !vesselPortVisits.length">
              <mat-icon>info</mat-icon>
              <span>No historical port stay records found for the applied filters.</span>
            </div>

            <!-- 1. TABLE LIST VIEW (Default) -->
            <div class="opt-table-responsive-container" *ngIf="vesselPortVisits.length > 0 && optVoyageViewMode === 'list'">
              <table class="opt-voyage-table">
                <thead>
                  <tr>
                    <th class="th-num">#</th>
                    <th class="th-voyage">Voyage</th>
                    <th class="th-vessel" *ngIf="!selectedVesselNames.length">Vessel</th>
                    <th class="th-port" *ngIf="!selectedPortNames.length">Port</th>
                    <th class="th-ops">Operation</th>
                    <th class="th-date">Start Date (UTC)</th>
                    <th class="th-date">End Date (UTC)</th>
                    <th class="th-metric th-bunker">Bunker (MT)</th>
                    <th class="th-metric">Idle (MT)</th>
                    <th class="th-metric">Manoeuvring (MT)</th>
                    <th class="th-metric th-opt">Opt Guidance (MT)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let visit of filteredVesselPortVisits; let i = index">
                    <td class="td-num">{{ i + 1 }}</td>
                    <td class="td-voyage">
                      <span class="opt-voyage-badge-sm">
                        {{ visit.voyage_number || ('#' + (filteredVesselPortVisits.length - i)) }}
                      </span>
                    </td>
                    <td class="td-vessel" *ngIf="!selectedVesselNames.length">
                      <strong>{{ visit.vessel_name }}</strong>
                    </td>
                    <td class="td-port" *ngIf="!selectedPortNames.length">
                      <strong>{{ visit.port }}</strong>
                    </td>
                    <td class="td-ops">
                      <span class="opt-table-tag" *ngIf="visit.operations">{{ visit.operations }}</span>
                      <span class="opt-table-tag opt-table-tag--segment" *ngIf="visit.segment">{{ visit.segment }}</span>
                    </td>
                    <td class="td-date">{{ formatVesselPortDate(visit.start_date) }}</td>
                    <td class="td-date">{{ formatVesselPortDate(visit.end_date) }}</td>
                    <td class="td-metric td-bunker">
                      <strong>{{ formatVesselPortMetric(visit.bunker_consumption) }}</strong>
                    </td>
                    <td class="td-metric">{{ formatVesselPortMetric(visit.idle_consumption) }}</td>
                    <td class="td-metric">{{ formatVesselPortMetric(visit.manoeuvring_consumption) }}</td>
                    <td class="td-metric td-opt">
                      <strong *ngIf="visit.optimization_guidance?.total != null" class="opt-teal-val">
                        {{ formatVesselPortMetric(visit.optimization_guidance?.total) }}
                      </strong>
                      <span *ngIf="visit.optimization_guidance?.total == null" class="opt-text-muted">—</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 2. CARDS VIEW (Optional view mode) -->
            <div class="opt-voyage-list" *ngIf="vesselPortVisits.length > 0 && optVoyageViewMode === 'cards'">
              <div
                class="opt-voyage-card"
                *ngFor="let visit of filteredVesselPortVisits; let i = index"
              >
                <!-- Voyage Header Bar -->
                <div class="opt-voyage-card__header">
                  <div class="opt-voyage-card__title-group">
                    <span class="opt-voyage-badge">
                      <mat-icon>sailing</mat-icon>
                      Voyage {{ visit.voyage_number || ('Call #' + (filteredVesselPortVisits.length - i)) }}
                    </span>
                    <span class="opt-voyage-tag" *ngIf="visit.operations">
                      {{ visit.operations }}
                    </span>
                    <span class="opt-voyage-tag opt-voyage-tag--segment" *ngIf="visit.segment">
                      {{ visit.segment }}
                    </span>
                    <span class="opt-voyage-date-range">
                      <mat-icon>schedule</mat-icon>
                      {{ formatVesselPortDate(visit.start_date) }} &ndash; {{ formatVesselPortDate(visit.end_date) }}
                    </span>
                  </div>
                </div>

                <!-- Two sections per voyage: 1. Actual Consumption, 2. Optimization Guidance -->
                <div class="opt-voyage-card__sections">
                  <!-- 1. Actual Consumption Subblock -->
                  <div class="opt-voyage-subblock opt-voyage-subblock--actual">
                    <div class="opt-voyage-subblock__header">
                      <span class="opt-voyage-subblock__title">
                        <mat-icon>speed</mat-icon> Actual Port Call Consumption
                      </span>
                    </div>
                    <div class="opt-kpi-grid opt-kpi-grid--5">
                      <article class="opt-kpi-card">
                        <div class="opt-kpi-card__icon opt-kpi-card__icon--amber">
                          <mat-icon>calendar_today</mat-icon>
                        </div>
                        <div class="opt-kpi-card__body">
                          <span class="opt-kpi-card__label">Start Date</span>
                          <strong class="opt-kpi-card__value opt-kpi-card__value--date">
                            {{ formatVesselPortDate(visit.start_date) }}
                          </strong>
                          <span class="opt-kpi-card__unit">UTC</span>
                        </div>
                      </article>

                      <article class="opt-kpi-card">
                        <div class="opt-kpi-card__icon opt-kpi-card__icon--amber">
                          <mat-icon>event</mat-icon>
                        </div>
                        <div class="opt-kpi-card__body">
                          <span class="opt-kpi-card__label">End Date</span>
                          <strong class="opt-kpi-card__value opt-kpi-card__value--date">
                            {{ formatVesselPortDate(visit.end_date) }}
                          </strong>
                          <span class="opt-kpi-card__unit">UTC</span>
                        </div>
                      </article>

                      <article class="opt-kpi-card">
                        <div class="opt-kpi-card__icon opt-kpi-card__icon--amber">
                          <mat-icon>local_gas_station</mat-icon>
                        </div>
                        <div class="opt-kpi-card__body">
                          <span class="opt-kpi-card__label opt-kpi-card__label--long">Bunker Consumption</span>
                          <strong class="opt-kpi-card__value">
                            {{ formatVesselPortMetric(visit.bunker_consumption) }}
                          </strong>
                          <span class="opt-kpi-card__unit">MT</span>
                        </div>
                      </article>

                      <article class="opt-kpi-card">
                        <div class="opt-kpi-card__icon opt-kpi-card__icon--amber">
                          <mat-icon>hourglass_empty</mat-icon>
                        </div>
                        <div class="opt-kpi-card__body">
                          <span class="opt-kpi-card__label">Idle Consumption</span>
                          <strong class="opt-kpi-card__value">
                            {{ formatVesselPortMetric(visit.idle_consumption) }}
                          </strong>
                          <span class="opt-kpi-card__unit">MT</span>
                        </div>
                      </article>

                      <article class="opt-kpi-card">
                        <div class="opt-kpi-card__icon opt-kpi-card__icon--amber">
                          <mat-icon>navigation</mat-icon>
                        </div>
                        <div class="opt-kpi-card__body">
                          <span class="opt-kpi-card__label opt-kpi-card__label--long">Manoeuvring Consumption</span>
                          <strong class="opt-kpi-card__value">
                            {{ formatVesselPortMetric(visit.manoeuvring_consumption) }}
                          </strong>
                          <span class="opt-kpi-card__unit">MT</span>
                        </div>
                      </article>
                    </div>
                  </div>

                  <!-- 2. Optimization Guidance Subblock -->
                  <div class="opt-voyage-subblock opt-voyage-subblock--guidance">
                    <div class="opt-voyage-subblock__header">
                      <span class="opt-voyage-subblock__title opt-voyage-subblock__title--guidance">
                        <mat-icon>verified</mat-icon> Optimization Guidance
                      </span>
                    </div>

                    <div class="opt-kpi-grid opt-kpi-grid--single" *ngIf="visit.optimization_guidance?.has_guidance">
                      <article class="opt-kpi-card">
                        <div class="opt-kpi-card__icon opt-kpi-card__icon--teal">
                          <mat-icon>lightbulb</mat-icon>
                        </div>
                        <div class="opt-kpi-card__body">
                          <span class="opt-kpi-card__label opt-kpi-card__label--long">Total Optimization Guidance</span>
                          <strong class="opt-kpi-card__value">
                            {{ formatVesselPortMetric(visit.optimization_guidance?.total) }}
                          </strong>
                          <span class="opt-kpi-card__unit">MT</span>
                        </div>
                      </article>
                    </div>

                    <div
                      class="opt-guidance-empty-note"
                      *ngIf="!visit.optimization_guidance?.has_guidance"
                    >
                      <mat-icon>info_outline</mat-icon>
                      <span>No specific optimization guidance metrics were recorded for this voyage.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <p class="opt-footnote" *ngIf="hasAnalysisResults()">
        All values are based on the selected filters and may vary accordingly.
      </p>
    </div>

  </main>

  <div class="opt-page__bottom-spacer" aria-hidden="true"></div>
</div>